import React from 'react';
import {Container, Dropdown, Menu} from "semantic-ui-react";
import {NavLink} from "react-router-dom";

export const People = ({history}) => {

    const data = JSON.parse(sessionStorage.getItem('Data'));

    return (
        <Menu secondary pointing inverted className={'main-menu red'}>
            <Container>
                <Menu.Item header
                           as={NavLink}
                           to={'/people/courses'}
                           content={'Meus Cursos'}
                />
                <Menu.Item header
                           as={NavLink}
                           to={'/people/orders'}
                           content={'Meus Pedidos'}
                />
                <Menu.Menu position='right'>
                    <Dropdown
                        as={Menu.Item}
                        text={data.people.name}
                    >
                        <Dropdown.Menu>
                            {/*<Dropdown.Item text='Perfil' />*/}
                            <Dropdown.Item text='Sair' onClick={() => {
                                sessionStorage.removeItem('Token')
                                sessionStorage.removeItem('Data')
                                history.push('/')
                            }}/>
                        </Dropdown.Menu>
                    </Dropdown>
                </Menu.Menu>
            </Container>
        </Menu>
    );
}